/**
 * Shared helpers for every FormID lookup component in this folder — extracted so
 * FormLookupField (normal + gear) and FormLookupFieldTwoMode (search/resolved) don't each
 * carry their own copy of "how do I read a FormID off an inconsistently-cased FormDefinition"
 * and "how do I format its display label." Both components delegate here rather than
 * duplicating this logic, per the consolidation task's SRP/reuse requirement.
 */

import type { FormDefinition } from '@atlas-forms/types-js';

export function getFormID(form: FormDefinition): number | undefined {
  return form.FormID ?? (form as any).FormId ?? (form as any).formID ?? (form as any).formId;
}

export function formatFormLabel(form: FormDefinition): string {
  const id = getFormID(form) ?? '?';
  const name = form.Name ?? (form as any).name ?? '';
  return name ? `${id} — ${name}` : String(id);
}
